import keyBy from 'lodash/keyBy';
import { RequestQuery, ServiceLocationsState } from 'types';

export const getServiceLocationsQuery = (practiceId: string | number): RequestQuery => {
  return {
    transform: ({ data }): { serviceLocations: ServiceLocationsState } => ({
      serviceLocations: keyBy(data, 'id'),
    }),
    update: {
      serviceLocations: (
        prev: ServiceLocationsState,
        next: ServiceLocationsState,
      ): ServiceLocationsState => ({
        ...prev,
        ...next,
      }),
    },
    url: `book/api/${practiceId}/service-locations`,
  };
};
